import ButtonPrimary from './ButtonPrimary';

export default ButtonPrimary;
